import { SampleTempType } from "@/lib/types";

export const sampleTempTypeOptions = [
  { label: "Ambient (2-25°C)", value: SampleTempType.Ambient },
  { label: "Refrigerated (2-8°C)", value: SampleTempType.Refrigerated },
  { label: "Frozen (<= 0°C)", value: SampleTempType.Frozen },
] as const;
